import { render, staticRenderFns } from "./DetalhesOrientacao.vue?vue&type=template&id=10a26e33&scoped=true"
import script from "./DetalhesOrientacao.vue?vue&type=script&lang=js"
export * from "./DetalhesOrientacao.vue?vue&type=script&lang=js"
import style0 from "./DetalhesOrientacao.vue?vue&type=style&index=0&id=10a26e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a26e33",
  null
  
)

export default component.exports